module.exports = function() {
  let CharacterCounter = {};

  CharacterCounter.countRemainingCharacters = function(message, maxLen) {
    let len = message.length;

    // Find campaign link placeholders in messages and calculate the actual length
    const placeholders = message.match(/\[@campaign\?\w+\.\w+\.{0,1}\w*\]/g);
    if (placeholders) {
      $.each(placeholders, function(i, placeholder) {
        len -= placeholder.length;

        var trueLen = placeholder.substring(
          placeholder.lastIndexOf('?') + 1,
          placeholder.lastIndexOf(']')
        ).length;
        trueLen += 'https://'.length;
        trueLen += '/xxxxxxx'.length; // auto generated short urls are 7 characters long

        len += trueLen;
      });
    }

    return maxLen - len;
  };

  return CharacterCounter;
};